// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyrightCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/CopyrightCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var CopyrightCircleTwoTone = function CopyrightCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightCircleTwoToneSvg
  }));
};

CopyrightCircleTwoTone.displayName = 'CopyrightCircleTwoTone';
export default React.forwardRef(CopyrightCircleTwoTone);